import { Booking } from "../types/booking";
import { AGENT_GOODS_READY_HIDDEN_STATUSES } from "../config/agentPortal";

const normalizeStatus = (status: string | null | undefined): string =>
  (status || "").replace(/-/g, "_");

export const shouldShowGoodsReadyColumn = (statusFilter: string): boolean =>
  !AGENT_GOODS_READY_HIDDEN_STATUSES.includes(
    statusFilter as (typeof AGENT_GOODS_READY_HIDDEN_STATUSES)[number]
  );

export const shouldShowGoodsReadyForBooking = (booking: Booking): boolean => {
  const status = normalizeStatus(booking.status);
  return !AGENT_GOODS_READY_HIDDEN_STATUSES.includes(
    status as (typeof AGENT_GOODS_READY_HIDDEN_STATUSES)[number]
  );
};
